export default "__VITE_ASSET__B$$Jdm4o__"